import { combineReducers } from 'redux'
import { combineEpics } from 'redux-observable'
import { routerReducer } from 'react-router-redux'

import orgReducer, { epic as orgEpic } from './org'
import userReducer, { epic as userEpic } from './user'
import profileReducer, { epic as profileEpic } from './profile'
import meetingsReducer, { epic as meetingsEpic } from './meetings'
import billingReducer, { epic as billingEpic } from './billing'
import geolocationReducer, { epic as geolocationEpic } from './geolocation'
import experimentReducer, { epic as experimentEpic } from './experiment'
import playbookReducer, { epic as playbookEpic } from './playbook'
import apiKeyReducer, { epic as apiKeyEpic } from './apiKey'
import { epic as authEpic } from './auth'
import stateReducer from './state'


import 'rxjs/add/observable/of'
import 'rxjs/add/observable/fromPromise'
import 'rxjs/add/observable/empty'

import 'rxjs/add/operator/pluck'
import 'rxjs/add/operator/first'
import 'rxjs/add/operator/switchMap'
import 'rxjs/add/operator/debounceTime'
import 'rxjs/add/operator/mapTo'
import 'rxjs/add/operator/do'
import 'rxjs/add/operator/ignoreElements'
import 'rxjs/add/operator/delay'

import '@drifthq/dapper/lib/rx/add/retryWithBackoff'
import '@drifthq/dapper/lib/rx/add/checkStatus'
import '@drifthq/dapper/lib/rx/add/mapResponse'

export const rootReducer = combineReducers({
  org: orgReducer,
  user: userReducer,
  profile: profileReducer,
  routing: routerReducer,
  meetings: meetingsReducer,
  billing: billingReducer,
  geolocation: geolocationReducer,
  experiment: experimentReducer,
  playbook: playbookReducer,
  state: stateReducer,
  apiKey: apiKeyReducer
})

export const rootEpic = combineEpics(
  orgEpic,
  profileEpic,
  userEpic,
  meetingsEpic,
  billingEpic,
  geolocationEpic,
  experimentEpic,
  playbookEpic,
  apiKeyEpic,
  authEpic,
)



// WEBPACK FOOTER //
// ./src/modules/index.js